import React from 'react';
import { CheckCircle, XCircle, Clock, MapPin, AlertCircle, Info } from 'lucide-react';
const ServiceCoverage = () => {
  return <div className="w-full" data-id="element-720">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-721">
        <div className="container mx-auto px-4" data-id="element-722">
          <div className="max-w-3xl mx-auto text-center" data-id="element-723">
            <h1 className="text-4xl font-bold mb-6" data-id="element-724">Service Coverage</h1>
            <p className="text-xl" data-id="element-725">
              Everything you need to know about our appliance repair coverage
              and service plans
            </p>
          </div>
        </div>
      </section>
      {/* Service Activation Section */}
      <section className="py-16" data-id="element-726">
        <div className="container mx-auto px-4" data-id="element-727">
          <div className="max-w-3xl mx-auto" data-id="element-728">
            <h2 className="text-3xl font-bold text-[#0a2e4a] mb-8" data-id="element-729">
              Service Activation & Start Date
            </h2>
            <div className="space-y-8" data-id="element-730">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-731">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-732">
                  When does my cover begin?
                </h3>
                <p className="text-gray-600" data-id="element-733">
                  Your protection starts immediately once your payment is
                  processed. You will receive a confirmation email shortly
                  afterwards.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-734">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-735">
                  Do I need to take any steps to activate my plan?
                </h3>
                <p className="text-gray-600" data-id="element-736">
                  No, activation happens automatically. Your plan begins as soon
                  as your purchase is complete and remains valid for 12 months.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-737">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-738">
                  When does my coverage end?
                </h3>
                <p className="text-gray-600" data-id="element-739">
                  Your plan expires exactly 12 months later at 23:59 on the
                  final day, unless you renew it beforehand.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Request Repair Section */}
      <section className="py-16 bg-gray-50" data-id="element-740">
        <div className="container mx-auto px-4" data-id="element-741">
          <div className="max-w-3xl mx-auto" data-id="element-742">
            <h2 className="text-3xl font-bold text-[#0a2e4a] mb-8" data-id="element-743">
              How Do I Request a Repair?
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-744">
              <p className="text-gray-600 mb-6" data-id="element-745">Please contact us by:</p>
              <div className="flex items-center mb-4" data-id="element-746">
                <div className="w-12 h-12 bg-[#e6f4fa] rounded-full flex items-center justify-center mr-4" data-id="element-747">
                  <Phone className="text-[#0a2e4a]" size={24} data-id="element-748" />
                </div>
                <a href="tel:08000554969" className="text-lg font-semibold text-[#0a2e4a]" data-id="element-749">
                  0800 055 4969
                </a>
              </div>
              <div className="flex items-center mb-6" data-id="element-750">
                <div className="w-12 h-12 bg-[#e6f4fa] rounded-full flex items-center justify-center mr-4" data-id="element-751">
                  <Mail className="text-[#0a2e4a]" size={24} data-id="element-752" />
                </div>
                <a href="mailto:sunitalimbu9596@gmail.com" className="text-lg font-semibold text-[#0a2e4a]" data-id="element-753">
                  sunitalimbu9596@gmail.com
                </a>
              </div>
              <p className="text-gray-600" data-id="element-754">
                Our team will organise your repair appointment, usually within
                24 to 48 hours.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Coverage Details Section */}
      <section className="py-16" data-id="element-755">
        <div className="container mx-auto px-4" data-id="element-756">
          <div className="max-w-3xl mx-auto" data-id="element-757">
            <h2 className="text-3xl font-bold text-[#0a2e4a] mb-8" data-id="element-758">
              What's Included?
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md mb-12" data-id="element-759">
              <ul className="space-y-4" data-id="element-760">
                <li className="flex items-start" data-id="element-761">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-762" />
                  <span className="text-gray-600" data-id="element-763">
                    Unlimited repair visits and callouts for appliances covered
                    during your 12-month plan
                  </span>
                </li>
                <li className="flex items-start" data-id="element-764">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-765" />
                  <span className="text-gray-600" data-id="element-766">
                    All labour costs are covered
                  </span>
                </li>
                <li className="flex items-start" data-id="element-767">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-768" />
                  <span className="text-gray-600" data-id="element-769">
                    Replacement parts provided when available
                  </span>
                </li>
                <li className="flex items-start" data-id="element-770">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-771" />
                  <span className="text-gray-600" data-id="element-772">
                    Engineer appointments are generally booked within 24–48
                    hours after reporting a fault
                  </span>
                </li>
                <li className="flex items-start" data-id="element-773">
                  <CheckCircle className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-774" />
                  <span className="text-gray-600" data-id="element-775">
                    Coverage includes mechanical and electrical faults
                  </span>
                </li>
              </ul>
            </div>
            <h2 className="text-3xl font-bold text-[#0a2e4a] mb-8" data-id="element-776">
              What's Not Covered?
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-777">
              <ul className="space-y-4" data-id="element-778">
                <li className="flex items-start" data-id="element-779">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-780" />
                  <span className="text-gray-600" data-id="element-781">
                    Cosmetic damage or normal wear and tear of appliances
                  </span>
                </li>
                <li className="flex items-start" data-id="element-782">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-783" />
                  <span className="text-gray-600" data-id="element-784">
                    Faults that existed prior to your plan start date
                  </span>
                </li>
                <li className="flex items-start" data-id="element-785">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-786" />
                  <span className="text-gray-600" data-id="element-787">
                    Damage caused by misuse or unauthorised repairs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-788">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-789" />
                  <span className="text-gray-600" data-id="element-790">
                    Appliances older than 10 years at the start of your plan
                  </span>
                </li>
                <li className="flex items-start" data-id="element-791">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-792" />
                  <span className="text-gray-600" data-id="element-793">
                    Damage due to floods, fires, or other natural disasters
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Service Area & Response Times Section */}
      <section className="py-16 bg-gray-50" data-id="element-794">
        <div className="container mx-auto px-4" data-id="element-795">
          <div className="max-w-3xl mx-auto" data-id="element-796">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-797">
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-798">
                <div className="flex items-center mb-4" data-id="element-799">
                  <MapPin className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-800" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-801">
                    Service Area
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-802">
                  We currently provide services across mainland UK postcodes
                  only. For remote areas, response times may be longer. Please
                  contact us to confirm if your location is covered.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-803">
                <div className="flex items-center mb-4" data-id="element-804">
                  <Clock className="text-[#f05a28] mr-3 flex-shrink-0" size={24} data-id="element-805" />
                  <h3 className="text-xl font-semibold text-[#0a2e4a]" data-id="element-806">
                    Response Times
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-807">
                  We aim to schedule engineer visits within 24 to 48 hours,
                  excluding weekends and public holidays.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Exclusions Section */}
      <section className="py-16" data-id="element-808">
        <div className="container mx-auto px-4" data-id="element-809">
          <div className="max-w-3xl mx-auto" data-id="element-810">
            <h2 className="text-3xl font-bold text-[#0a2e4a] mb-8" data-id="element-811">
              Plan Exclusions & Prohibited Use
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-812">
              <p className="text-gray-600 mb-6" data-id="element-813">
                To ensure fair use and maintain service quality, the following
                are excluded from cover:
              </p>
              <ul className="space-y-4 mb-6" data-id="element-814">
                <li className="flex items-start" data-id="element-815">
                  <AlertCircle className="text-[#f05a28] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-816" />
                  <span className="text-gray-600" data-id="element-817">
                    Damage or faults existing before your plan started
                  </span>
                </li>
                <li className="flex items-start" data-id="element-818">
                  <AlertCircle className="text-[#f05a28] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-819" />
                  <span className="text-gray-600" data-id="element-820">
                    Damage caused by neglect, misuse, or tampering
                  </span>
                </li>
                <li className="flex items-start" data-id="element-821">
                  <AlertCircle className="text-[#f05a28] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-822" />
                  <span className="text-gray-600" data-id="element-823">
                    Repairs unrelated to normal appliance operation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-824">
                  <AlertCircle className="text-[#f05a28] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-825" />
                  <span className="text-gray-600" data-id="element-826">
                    Any illegal or fraudulent use of our services or website
                  </span>
                </li>
                <li className="flex items-start" data-id="element-827">
                  <AlertCircle className="text-[#f05a28] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-828" />
                  <span className="text-gray-600" data-id="element-829">
                    Appliances used contrary to manufacturer instructions
                  </span>
                </li>
              </ul>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4" data-id="element-830">
                <div className="flex items-start" data-id="element-831">
                  <Info className="text-yellow-500 mr-3 flex-shrink-0" size={20} data-id="element-832" />
                  <p className="text-sm text-gray-600" data-id="element-833">
                    Please note: If any of these exclusions apply, your plan may
                    be cancelled without refund or further support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-[#0a2e4a] text-white" data-id="element-834">
        <div className="container mx-auto px-4" data-id="element-835">
          <div className="max-w-3xl mx-auto text-center" data-id="element-836">
            <h2 className="text-3xl font-bold mb-6" data-id="element-837">Ready to Get Protected?</h2>
            <p className="text-xl mb-8" data-id="element-838">
              Choose one of our service plans today and enjoy peace of mind for
              your appliances.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-839">
              <a href="/" className="bg-white text-[#0a2e4a] px-8 py-3 rounded-md font-semibold text-center hover:bg-gray-100 transition" data-id="element-840">
                View Service Plans
              </a>
              <a href="/contact" className="bg-[#f05a28] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#d94e20] transition" data-id="element-841">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default ServiceCoverage;
// Need to define these imports
import { Phone, Mail } from 'lucide-react';